/* External */
import { all } from "redux-saga/effects";

/* Services */
import { backendService } from "../../../services";

/* Others */
import { ACTION_TYPES_BASE_NAME } from "./actions";
import { makeFetchSaga } from "../../../utils";

const fetchPdpSeasonSaga = makeFetchSaga(ACTION_TYPES_BASE_NAME, {
  func: backendService.content.getSeasonById,
  getParams: ({ seasonId }) => [seasonId]
});

export default function* () {
  yield all([fetchPdpSeasonSaga]);
}
